module.exports = __webpack_public_path__ + "img/bling.b5465288.svg";